import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { EnumIroType } from '~/types/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'recursiveEsrs',
  props: {
  fullHeaders: {
    type: Array,
    required: true,
  },
  item: {
    type: Object,
    required: true,
  },
  allItems: {
    // need to use all items because sections should be flat (not nested)
    type: Array,
    required: true,
  },
  getCommentValue: {
    type: Function,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const getChildItems = (parentId, items) => {
  const children = items.filter((item) => item.parentId === parentId)
  return children
}

const childItems = computed(() => getChildItems(props.item.id, props.allItems))

const rowClasses = (item) => {
  return item.hasChildren ? 'font-bold bg-gray-50' : ''
}

return { __sfc: true,props, getChildItems, childItems, rowClasses, EnumIroType }
}

})